import {
  ApplicationsTypeEnum,
  ProductTypeEnum,
} from '@shared/constants/select-options.enums';
import {
  getCurrentAddressSearchBase,
  getCurrentAosBase,
  getCurrentApiBase,
  getCurrentAsappApiBase,
  getCurrentEmailBase,
  getCurrentMemberBase,
  getCurrentUserManagementBase,
  getReportBase,
  getKeyVaultBase,
  getEcmBase,
  getVersioningBase,
  getOfferApiBase,
  getLendingDecisioningApiBase,
  getComplianceManagementApiBase,
  getConfigurationManagementApiBase,
  getCurrentApplicationBase,
  getCurrentProductBase,
  getCurrentIdentityVerificationBase,
  getDocumentManagementService,
  getCoreBanking,
  getContentBase,
  getBankIoRetailBase,
  getCurrentCoreBankingBase,
} from '@config/org.config';
import { DiscardScheduleReq } from '@core/services/dto/sql-schedule-config.dto';

const apiBase = getCurrentApiBase();
const memberBase = getCurrentMemberBase();
const coreBankingBase = getCurrentCoreBankingBase();
const emailBase = getCurrentEmailBase();
const canadaPostAddressBase = getCurrentAddressSearchBase();
const userManagementBase = getCurrentUserManagementBase();
const applicationBase = getCurrentApplicationBase();
const reportingBase = getReportBase();
const asappApiBase = getCurrentAsappApiBase();
const keyVaultBase = getKeyVaultBase();
const ecmBase = getEcmBase();
const versioningBase = getVersioningBase();
const offerBase = getOfferApiBase();
const LDSBase = getLendingDecisioningApiBase();
const complianceApiBase = getComplianceManagementApiBase();
const configurationManagementApiBase = getConfigurationManagementApiBase();
const productBase = getCurrentProductBase();
const identityVerificationApiBase = getCurrentIdentityVerificationBase();
const documentManagementService = getDocumentManagementService();
const coreBanking = getCoreBanking();
const contentBase = getContentBase();
const bankIoRetailBase = getBankIoRetailBase();


export const AuthUrls = {
  login: `${userManagementBase}/login`,
};

export const EmailUrls = {
  templates: `${emailBase}/templates`,
  templatesOrigination: `${emailBase}/templates/origination`,
  templateById: (id: string) => `${emailBase}/templates/${id}`,
  sendBulk: `${emailBase}/send/Taskbulk`,
  send: `${emailBase}/send`,
  sendLogs: `${apiBase}/changeLogHistory`,
  attachments: `${emailBase}/attachments`,
  attachment: (id: number) => `${emailBase}/attachments/${id}`,
  layout: `${emailBase}/layouts`,
  defaultLayout: `${emailBase}/layouts/default`,
  layoutById: (id: number) => `${emailBase}/layouts/${id}`,
  updateTasklink: `${apiBase}/linktable`,
  emailTemplate: (templateType: string) =>
    `${emailBase}/templates/GetEmailTEmplaPublic?TemplateType=${templateType}`,
};

export const SMSUrls = {
  smstemplates: `${emailBase}/templates/SMSTemplate`,
  templates: `${emailBase}/templates`,
  SendSms: `${emailBase}/SendSms`,
  sendBulkSms: `${emailBase}/smstemplate/sendsms`,
  templateById: (id: string) => `${emailBase}/smsTemplates/${id}`,
};

export const MemberUrls = {
  member: (memberId: number) => `${memberBase}/members/${memberId}`,
  review: (memberId: number) => `${memberBase}/members/${memberId}/review`,
  members: `${memberBase}/members`,
  import: (memberNumber: string, memberType: string) =>
    `${memberBase}/members/${memberNumber}/${memberType}/sync`,
  importById: (memberId: number) => `${memberBase}/members/${memberId}/sync`,
  coreBanking: (memberNumber: number) =>
    `${memberBase}/corebanking/members?memberNumber=${memberNumber}`,
  bankIntegrationConfiguration: `${memberBase}/corebanking/bank-integration-configuration`,
  summary: (memberId: number, statuses: string[], isProspectInfo: boolean) =>
    `${apiBase}/member-summary?memberId=${memberId}&taskStatuses=${statuses}&isProspectInfo=${isProspectInfo}`,
  person: (personId: number) => `${memberBase}/persons/${personId}`,
  addOrUpdateMemberAddress: (personId: number) => `${memberBase}/persons/${personId}/AddOrUpdateMemberAddress`,
  organization: (orgId: number) => `${memberBase}/organizations/${orgId}`,
  authenticate: (
    memberId: number,
    deliveryType: string,
    memberType: string
  ) => `${memberBase}/MemberAuthenticate?memberId=${memberId}
  &deliveryType=${deliveryType}&memberType=${memberType}`,
  sendcode: () => `${memberBase}/MemberAuthenticate/SendCode`,
  addresses: (personId: number, type: string) =>
    `${memberBase}/${type}/${personId}/addresses`,
  address: (personId: number, type: string, addressId: number) =>
    `${memberBase}/${type}/${personId}/addresses/${addressId}`,
  createAddress: (type: string, personId: number) =>
    `${memberBase}/${type}/${personId}/addresses`,
  employments: (personId: number) =>
    `${memberBase}/persons/${personId}/employments`,
  updateEmployment: (personId: number, employmentId: number) =>
    `${memberBase}/persons/${personId}/employments/${employmentId}`,
  contacts: (personId: number) => `${memberBase}/persons/${personId}/contacts`,
  personContacts: `${memberBase}/persons/contacts`,
  organizationContacts: `${memberBase}/organizations/contacts`,
  orgContacts: (orgId: number) =>
    `${memberBase}/organizations/${orgId}/contacts`,
  preferences: (personId: number) =>
    `${memberBase}/persons/${personId}/contacts/preferences`,
  orgPreferences: (orgId: number) =>
    `${memberBase}/organizations/${orgId}/contacts/preferences`,
  updateContact: (personId: number, contactId: number) =>
    `${memberBase}/persons/${personId}/contacts/${contactId}`,
  updateOrgContact: (orgId: number, contactId: number) =>
    `${memberBase}/organizations/${orgId}/contacts/${contactId}`,
  deleteContact: (personId: number, contactId: number) =>
    `${memberBase}/persons/${personId}/contacts/${contactId}`,
  deleteOrgContact: (orgId: number, contactId: number) =>
    `${memberBase}/organizations/${orgId}/contacts/${contactId}`,
  identificationDocuments: (personId: number, type: string) =>
    `${memberBase}/${type}/${personId}/documents`,
  branches: `${memberBase}/branches`,
  syncAccounts: (memberId: number) =>
    `${memberBase}/members/${memberId}/accounts/sync`,
  lendings: (accountId: number) => `${memberBase}/lendings/${accountId}`,
  lendingHolds: (accountId: number) =>
    `${memberBase}/lendings/${accountId}/holds`,
  lendingCollateral: (accountId: number) =>
    `${memberBase}/lendings/${accountId}/collateral`,
  savings: (accountId: number) => `${memberBase}/savings/${accountId}`,
  savingHolds: (accountId: number) =>
    `${memberBase}/savings/${accountId}/holds`,
  allLendings: (memberId: number) =>
    `${memberBase}/members/${memberId}/lendings`,
  allSavings: (memberId: number) => `${memberBase}/members/${memberId}/savings`,
  provinces: `${memberBase}/provinces`,
  countries: `${memberBase}/countries`,
  people: (memberId: number) => `${memberBase}/members/${memberId}/joints`,
  joints: (jointId: number) => `${memberBase}/joints/${jointId}`,
  accounts: `${memberBase}/accounts`,
  accountsCount: (memberId: number) =>
    `${memberBase}/accounts/count?memberId=${memberId}`,
  checkHouseholdAssociation: `${memberBase}/households/check-association`,
  households: `${memberBase}/households`,
  household: (householdId: number) => `${memberBase}/households/${householdId}`,
  offerCount: (memberId: number, statuses: string[]) =>
    `${offerBase}/offer-members-count?memberId=${memberId}&OfferStatuses=${statuses}`,
  accessHistory: (memberId: number) =>
    `${memberBase}/profilehistory?MemberorProspectId=${memberId}`,
  creditReportHistory: `${memberBase}/creditReportHistory`,
  crReportDownloadXML: (id) =>
    `${memberBase}/creditReportHistory/downloadXml/${id}`,
  creditReportDownloadJson: (id) =>
    `${memberBase}/creditReportHistory/downloadJson/${id}`,
  downloadEquifaxUSPdf: (id) =>
    `${memberBase}/creditReportHistory/downloadPdf/${id}`,
  creditReportView: (id) =>
    `${memberBase}/creditReportHistory/getCreditReportContentsById/${id}`,
  newCreditReportView: (id) => `${memberBase}/creditReport?MemberNumber=${id}`,
  newCreditReportByEmail: (emailId) =>
    `${memberBase}/creditReport?email=${emailId}`,
  addRepresentative: `${memberBase}/memberrepresentatives`,
  getMemberRepresentative: (memberId: number) =>
    `${memberBase}/memberrepresentative/${memberId}/M`,
  getProspectRepresentative: (prospectId: number) =>
    `${memberBase}/memberrepresentative/${prospectId}/P`,
  updateRepresentative: `${memberBase}/memberrepresentative`,
  deleteRepresentative: (id) => `${memberBase}/memberrepresentative/${id}`,
  checkUserMemberRepresentativeAdded: (userId, userGroupId) =>
    `${memberBase}/memberrepresentative/isuserorusergroupexist?UserId=${userId}&UserGroupId=${userGroupId}`,
  checkGroupMemberRepresentativeAdded: (UserGroupId) =>
    `${memberBase}/memberrepresentative/isuserorusergroupexist?UserGroupId=${UserGroupId}`,
  deleteUserGroupFromMemberRepresentative: (userGroupId) =>
    `${memberBase}/memberrepresentative?UserGroupId=${userGroupId}`,
  deleteUserFromMemberRepresentative: (userId, userGroupId) =>
    `${memberBase}/memberrepresentative?UserId=${userId}&UserGroupId=${userGroupId}`,
  twillio: (siteId: string) =>
    `${memberBase}/MemberAuthenticate/TwilioConfiguration?siteId=${siteId}`,
  getAddressFields: (countryCode: string, addressType: string) =>
    `${memberBase}/GetAddressFields?countryCode=${countryCode}&addressType=${addressType}`,
  getAddressFieldsByType: (countryCode: string, addressType: string) =>
    `${memberBase}/GetAddressFields/GetLableByAddressType?countryCode=${countryCode}&addressType=${addressType}`,
  getAddressFieldsByCountryId: (countryId: number, addressType: string) =>
    `${memberBase}/GetAddressFields/GetLableByAddressType?countryId=${countryId}&addressType=${addressType}`,
  getAddressFlags: (countryCode: string) =>
    `${memberBase}/GetAddressTypes?countryCode=${countryCode}`,
  existCreditReportRequestModel: `${memberBase}/creditReport/GetCreditReportwithChkOnRefreshApplication `,
  creditReport: `${memberBase}/CreditReport`,
  getLatestCreditReport: `${memberBase}/CreditReport/GetLatestCreditReport`,
  UpdateProspectIntoMember: `${memberBase}/BankIOApplication/UpdateProspectIntoMember`,
  getMemberIdByMemberNumber: (memberNumber: string) => `${memberBase}/BankIOMember/getMemberIdByMemberNumber/${memberNumber}`,
  BankIOMemberAddOrUpdateMember: `${memberBase}/BankIOMember/addOrUpdateMember`,
  getApplicationLinkedMemberInfo: (applicationId: number) =>
    `${memberBase}/BankIOApplication/GetApplicationLinkedMemberLoginInfo?applicationId=${applicationId}`,
  sendEmailVerificationLink: `${memberBase}/BankIOMember/SendSetPasswordEmailVerificationLink`,
  getAllAssets: `${memberBase}/api/BankIOMemberAssets/GetAllAssets`,
  getAllLiabilities: `${memberBase}/BankIOMemberLiabilities/GetLiabilities`,
  printLiabilities: `${memberBase}/BankIOMemberLiabilities/PrintLiability`,
  downloadLiabilities: `${memberBase}/BankIOMemberLiabilities/DownloadLiabilitiesZip`,
  getAssetsById: `${memberBase}/api/BankIOMemberAssets/GetAssetsById`,

};

export const UserUrls = {
  users: `${apiBase}/users`,
  userGroups: `${apiBase}/usergroups`,
};

export const LinksUrls = {
  linksPrivate: `${apiBase}/links/private`,
  linkPrivate: (id: number) => `${apiBase}/links/${id}/private`,
  linksPublic: `${apiBase}/links/public`,
  linkPublic: (id: number) => `${apiBase}/links/${id}/public`,
};
export const SetupUrls = {
  complianceManagement: `${complianceApiBase}/Compliance`,
  complianceManagementChangelogs: `${complianceApiBase}/Compliance/ChangeLog`,
  complianceManagementDetails: (id: number) =>
    `${complianceApiBase}/Compliance/${id}`,
  complianceLocalizationAddOrUpdate: `${complianceApiBase}/ComplianceLocalization/AddOrUpdateComplianceLocalization`,
  complianceLocalization: (id: number, languageCode: string) =>
    `${complianceApiBase}/ComplianceLocalization/${id}/${languageCode}`,
};

export const PromoPageUrls = {
  promoPages: `${contentBase}/PromoPages`,
  promoPage: (id: number) => `${contentBase}/PromoPages/${id}`,
  promoPageTranslation: `${contentBase}/api/PromoPageLocalization`,
  promoPageLocalization: (id: number, languageCode: string) =>
    `${contentBase}/api/PromoPageLocalization?promoPageId=${id}&languageCode=${languageCode}`,
  deletePromoBanner: `${contentBase}/PromoPages/DeletePromoPagebanner`
};



export const TaskUrls = {
  tasksHistory: `${apiBase}/changeLogHistory`,
  tasks: `${apiBase}/tasks`,
  task: (id: number) => `${apiBase}/tasks/${id}`,
  taskTemplates: `${apiBase}/task-templates`,
  taskTemplate: (id: number) => `${apiBase}/task-templates/${id}`,
  summary: (statuses: string[]) =>
    `${apiBase}/task-summary?taskStatuses=${statuses}`,
  updateSendDate: (id: string, emailId: string) =>
    `${apiBase}/tasks/${id}/emails/${emailId}`,
  updatetaskLink: `${apiBase}/linktable`,
};

export const ConversationUrls = {
  conversationsHistory: `${apiBase}/changeLogHistory`,
  conversations: `${apiBase}/conversations`,
  concerns: `${apiBase}/concerns`,
  concerntypes: `${apiBase}/concern-types`,
  opportunities: `${apiBase}/opportunities`,
  conversation: (id: number) => `${apiBase}/conversations/${id}`,
  concern: (id: number) => `${apiBase}/concerns/${id}`,
  concerntype: (id: number) => `${apiBase}/concern-types/${id}`,
  opportunity: (id: number) => `${apiBase}/opportunities/${id}`,
  summary: `${apiBase}/conversation-summary`,
  conversationWorkflows: (id: number) =>
    `${apiBase}/conversations/${id}/workflows`,
  conversationImports: `${apiBase}/conversation-imports`,
  conversationImport: (id: number) => `${apiBase}/conversation-imports/${id}`,
  conversationImportTemplate: (id: number) =>
    `${apiBase}/conversation-imports/template/${id}`,
  importedConversationEmails: `${apiBase}/GetImportedConversationEmails`,
  conversationAssineetBatch: `${apiBase}/conversations/BatchAssignment`,
  concernsAssineetBatch: `${apiBase}/concerns/BatchAssignment`,
  opportunitiesAssineetBatch: `${apiBase}/opportunities/BatchAssignment`,
  tasksAssineetBatch: `${apiBase}/tasks/BatchAssignment`,
  isCrmObjectExists: (id: number) =>
    `${apiBase}/usergroupsummary/activeCRMrecords?assigneeId=${id}`,
};

export const BankIOConversationActionsUrls = {
  markAsReadAll: `${apiBase}/bankIO/interactions/MarkAsReadAll`,
};

export const ReportUrls = {
  salesReport: `${apiBase}/reports/sales-report`,
  salesReportExport: `${apiBase}/reports/sales-report/export`,
  opportunityReport: `${apiBase}/reports/opportunity-status-report`,
  taskReport: `${apiBase}/reports/task-status-report`,
  opportunityReportExport: `${apiBase}/reports/opportunity-status-report/export`,
  taskReportExport: `${apiBase}/reports/task-status-report/export`,
  interactionReport: `${apiBase}/reports/interactions-report`,
  pipelineReport: `${apiBase}/reports/pipeline-report`,
  userReport: `${userManagementBase}/reports/license-report`,
  userReportExport: `${userManagementBase}/reports/license-report/export`,
  referralReport: `${apiBase}/reports/referral-report`,
  referralReportExport: `${apiBase}/reports/referral-report/export`,
  offerActivityReport: `${offerBase}/reports/offer-activity-report`,
  offerActivityReportExport: `${offerBase}/reports/offer-activity-report/export`,
  pipelineReportExport: `${apiBase}/reports/pipeline-report/export`,
};

export const SqlBuilderUrls = {
  sqlBuilderOptions: `${reportingBase}/options`,
  sqlTemplates: `${reportingBase}/templates`,
  sqlTemplate: (id: number) => `${reportingBase}/templates/${id}`,
  queryData: `${reportingBase}/templates/build`,
  export: `${reportingBase}/templates/export`,
  exportOpportunities: `${reportingBase}/templates/export-for-opportunity-import`,
  exportOffers: `${reportingBase}/templates/export-for-offer-import`,
  templateConfig: `${reportingBase}/templatefields`,
  templateConfigUpdate: (id: number) => `${reportingBase}/templateFields/${id}`,
  buildImport: `${reportingBase}/templates/build-import`,

  saveScheduleConfigTemplate: `${reportingBase}/ScheduleConfiguration`,
  getScheduleConfigTemplate: (id: number, ScheduleId: number) =>
    `${reportingBase}/ScheduleConfiguration?id=${id}&ScheduleId=${ScheduleId}`,
  updateSchedule: (id: number) =>
    `${reportingBase}/ScheduleConfiguration/${id}`,
  discardSchedule: (request: DiscardScheduleReq) =>
    `${reportingBase}/ScheduleConfiguration/${request.id}/discard?templateId=${request.templateId}`,
  resetSchedule: (id: number) => `${reportingBase}/ScheduleList/Schedule/${id}`,
  skipSchedule: `${reportingBase}/ScheduleList`,
  extendSchedule: (id: number) =>
    `${reportingBase}/ScheduleConfiguration/${id}/ExtendDate`,
};

export const ProductUrls = {
  productTypes: `${apiBase}/product-types`,
  products: `${apiBase}/products`,
  externalProducts: (categoryId: number) =>
    `${contentBase}/api/ProductController1/GetProductByCategoriesId?categoryId=${categoryId}`,
  externalProductCategories: `${contentBase}/api/ProductController1/GetPRoductsCategories`,
  campaigns: `${apiBase}/campaigns`,
  campaign: (id: number) => `${apiBase}/campaigns/${id}`,
  productType: `${ecmBase}/files/ProductTypes`,
  product: `${ecmBase}/files/GetProducts`,
};

export const InteractionUrls = {
  interactions: `${apiBase}/interactions`,
  getApplicationInteractions: `${apiBase}/interactions/GetApplicationAsync`,
  interactionsHistory: `${apiBase}/changeLogHistory`,
  interaction: (id: number) => `${apiBase}/interactions/${id}`,
};

export const AnnouncementUrls = {
  announcements: `${apiBase}/announcements`,
  announcementUser: `${apiBase}/announcements/user`,
  announcement: (id: number) => `${apiBase}/announcements/${id}`,
};

export const RecentActivityUrls = {
  summary: `${apiBase}/summary`,
  memberSummary: `${memberBase}/summary`,
};

export const NoteUrls = {
  notesHistory: `${apiBase}/changeLogHistory`,
  notes: `${apiBase}/notes`,
  note: (id: number) => `${apiBase}/notes/${id}`,
};

export const WorkflowUrls = {
  workflowTemplates: `${apiBase}/workflow-templates`,
  workflowTemplate: (id: number) => `${apiBase}/workflow-templates/${id}`,
  workflow: (id: number) => `${apiBase}/workflows/${id}`,
  workFlowTasksAssineetBatch: `${apiBase}/workflow-templates/BatchAssignment`,
};

export const FileUrls = {
  files: `${apiBase}/files`,
  uploadIcon: `${apiBase}/files/uploadIcon`,
  file: (id: number) => `${apiBase}/files/${id}`,
};

export const CanadaPostAddressUrls = {
  search: (
    search: string,
    id: string,
    IsGoogleActivated: boolean,
    countryCode: string
  ) =>
    `${canadaPostAddressBase}/address-search/find?search=${search}&id=${id}&isgoogleActivated=${IsGoogleActivated}&countryCode=${countryCode}`,
    
  get: (id: string, IsGoogleActivated: boolean, countryCode: string) =>
    `${canadaPostAddressBase}/address-search/retrieve?id=${id}&isgoogleActivated=${IsGoogleActivated}&countryCode=${countryCode}`,
};

export const UserManagementUrls = {
  users: `${userManagementBase}/users`,
  allusers: `${userManagementBase}/users/getAllUsers`,
  usersChangeLog: `${userManagementBase}/users/changelog`,
  branch: `${userManagementBase}/branches/getAllBranches`,
  user: (id: string) => `${userManagementBase}/users/${id}`,
  updateUserEmail: (id: string, email: string) =>
    `${userManagementBase}/users/${id}/update?email=${encodeURIComponent(
      email
    )}`,
  permissions: (id: string) => `${userManagementBase}/users/${id}/permissions`,
  permissionsReport: `${userManagementBase}/permission/export-user-permissions`,
  groups: (id: string) => `${userManagementBase}/users/${id}/groups`,
  resetPassword: (email: string) =>
    `${userManagementBase}/users/reset-password/${email}`,
  sendActivation: (email: string) =>
    `${userManagementBase}/users/send-activation/${email}`,
};

export const CategoryManagementUrls = {
  categories: `${productBase}/ProductCategory`,
  deleteCategories: `${productBase}/ProductCategory`,
  categoryChangeLog: `${productBase}/ProductCategory/changeLog`,
  updateCategory: `${productBase}/ProductCategory`,
  updateCategoryLocalization: `${productBase}/ProductCategory/AddOrUpdateLocalization`,
  updateCategoryRank: () => `${productBase}/ProductCategory/UpdateRank`,
  categoryById: `${productBase}/ProductCategory/GetById`,
  legalTerms: `${productBase}/SyncedCompliance/GetAllByCategory?requestId=555&category=LegalTerm&status=Active&type=Retail`,
  productType: `${productBase}/GetAllSiteProductType`,
};

export const ContentManagementUrls = {
  contents: `${contentBase}/ContentBlocks/GetAllContentBlock`,
  contentPageNames: `${contentBase}/ContentBlocks/GetPageNames`,
  getContentById: (id: number) => `${contentBase}/ContentBlocks/GetById?id=${id}`,
  contentChangeLog: `${contentBase}/ContentBlocks/GetAllChangeLog`,
  updateContentBlock: `${contentBase}/ContentBlocks/UpdateContentBlock`,
};

export const ProductManagementUrls = {
  products: `${productBase}/Product/GetAll`,
  productSubType: `${productBase}/ProductSubTypee`,
  deleteProducts: `${productBase}/Product/DeleteProduct`,
  productChangeLog: `${productBase}/Products/changeLog`,
  updateProduct: `${productBase}/Products`,
  addUpdateProductLocalization: `${productBase}/Product/AddOrUpdateLocalization`,
  updateProductsRank: () => `${productBase}/Product/UpdateProductRank`,
  productsById: `${productBase}/Product/GetProductById`,
  complianceByProductId: `${productBase}/ProductCompliance/GetProductComplianceById`,
  saveDepositOrSavingProduct: `${productBase}/Product/CreateDepositAndSavingProduct`,
  allCategories: `${productBase}/ProductCategory/GetAllCategories`,
  allCompliance: `${productBase}/Compliance/GetAll`,
  saveLendingProduct: `${productBase}/Product/CreateLendingProduct`,
  changeLog: `${productBase}/ChangeLog`,
  GetAllProductLogs: `${productBase}/ChangeLog/GetAllProductLogs`,
  AddorUpdaterProductTag: `${productBase}/ProductTag/AddorUpdaterProductTag`,
  applicationsByProductIds: () => `${applicationBase}/api/ApplicationProducts/GetApplicationsByProductIds`,
  updateDepositOrSavingProduct: `${productBase}/Product/UpdateDepositAndSavingProduct`,
  updateDepositConfiguration: `${productBase}/Product/UpdateDepositConfiguration`,
  updateLendingProduct: `${productBase}/Product/UpdateLendingProduct`,
  updateLendingProductConfiguration: `${productBase}/Product/UpdateLendingProductConfiguration`,
  updateComplianceConfiguration: `${productBase}/Product/UpdateComplianceConfiguration`,
  updateTermConfiguration: `${productBase}/ProductTerm/UpdateTermConfiguration`,
  updateAllowRateOverride: `${productBase}/Product/UpdateAllowRateOverride`,
  getApprovalAndRate: `${productBase}/SyncedApprovalAndRate/GetAllApprovalAndRate`,
  getAutoDecisionSettings: `${productBase}/api/ProductAutoDecision/GetProductAutoDecision`,
  addUpdateAutoDecisionSettings: `${productBase}/api/ProductAutoDecision/AddORUpdateProductAutoDecision`,
  getAllCampaign: `${productBase}/SyncedCampaign/GetAllCampaign`,
  updateProductCrm: `${productBase}/ProductCRM`,
  getProductCrm: `${productBase}/ProductCRM`,
  getProductCoreBanking: `${productBase}/ProductCoreBanking/GetByProductId`,
  updateProductCoreBanking: `${productBase}/ProductCoreBanking`,
  createProductCoreBanking: `${productBase}/ProductCoreBanking`,
  getAllWorkflow: `${productBase}/SyncedWorkFlow/GetAllWorkFlow`,
  assetType: `${productBase}/AssetType/GetAllAssetsWithSubAssets`,
  productAssetType: `${productBase}/ProductAssetType`,
  saveProductAssetType: `${productBase}/ProductAssetType`,
  updateProductTypeIntendedUseLocalization: `${productBase}/AddOrUpdateLocalization`,
  updateProductTypeConditionsLocalization: `${productBase}/AddOrUpdateConditions`,
  updateProductTypePolicyLocalization: `${productBase}/AddOrUpdatePolicy`,
  getProductTerms: (productId: number) => `${productBase}/ProductTerm/GetByProductId?productId=${productId}`,
  getAmoritization: (productId: number) => `${productBase}/ProductAmortization/GetByProductId?productId=${productId}`,
  getPaymentFrequencies: (productId: number) => `${productBase}/ProductPaymentFrequency/GetByProductIdForConfig?productId=${productId}`,
  updateProductIntendedUseLocalization: `${productBase}/UpdateIntendedValuesAndProductLocalization`,
  updateTermLocalization: `${productBase}/ProductTerm/UpdateTermLocalization`,
  updateAmortizationLocalization: `${productBase}/ProductAmortization/UpdateAmortizationLocalization`,
};

export const BranchManagementUrls = {
  allBranches: `${userManagementBase}/branches/getAllBranches`,
  branches: `${userManagementBase}/branches`,
  branchChangeLog: `${userManagementBase}/branches/branchChangeLog`,
  branch: (id: number) => `${userManagementBase}/branches/${id}`,
};
export const UserGroupManagementUrls = {
  groups: `${userManagementBase}/groups`,
  groupDetails: (id: number) => `${userManagementBase}/groups/${id}`,
  groupUsers: (id: number) => `${userManagementBase}/groups/${id}/users`,
  userGroupDetails: (id: number, groupId: number) =>
    `${userManagementBase}/users/${id}/groups/${groupId}`,
};

export const EmailNotificationUrls = {
  emailNotifications: (hasGroup: boolean) =>
    `${userManagementBase}/EmailNotificationPermission?hasGroup=${hasGroup}`,
  emailNotification: `${userManagementBase}/EmailNotificationPermission`,
};

export const SaleUrls = {
  saleHistory: `${apiBase}/changeLogHistory`,
  sales: `${apiBase}/sales`,
  sale: (id: number) => `${apiBase}/sales/${id}`,
  saleProducts: `${apiBase}/sale-products`,
  saleForOpportunity: (search: string) =>
    `${apiBase}/sales?searchParam=${search}`,
};

export const AsappServiceUrls = {
  applications: `${asappApiBase}/applications`,
  statuses: `${asappApiBase}/applications/counts`,
  occupations: `${asappApiBase}/site/occupations`,
  autocomplete: `${asappApiBase}/site/getGoogleAutocompleteEnabled`,
  siteDetails: `${configurationManagementApiBase}/site/GetAllDataBySiteId`,
  userBranch: `${asappApiBase}/site/getBranch`,
};

export const ApplicationUrls = {
  applications: `${applicationBase}/applications/GetAllApplications`,
  applicationLog: `${applicationBase}/applications/GetApplicationLogs`,
  count: `${applicationBase}/applications/GetCount`,
  files: `${applicationBase}/files`,
  notes: `${applicationBase}/notes`,
  staffUsers: `${applicationBase}/User/GetStaffUser`,
  products: `${productBase}/Product/GetAll`,
  branches: `${applicationBase}/SyncBranch/SyncBranchRecord`,
  note: (id: number) => `${applicationBase}/notes/${id}`,
  applicationSummary: (applicationId: number) =>
    `${applicationBase}/Applications/GetApplicationSummaryById?applicationId=${applicationId}`,
  getAllAssetTypes: `${applicationBase}/AssetsLiabilities/GetAllAssetTypes`,
  applicationAsset: (applicationId: number) =>
    `${applicationBase}/AssetsLiabilities/GetApplicationAssets?applicationId=${applicationId}`,
  applicationAssetByGroup: (applicationId: number) =>
    `${applicationBase}/AssetsLiabilities/GetApplicationAssetsByGroup?applicationId=${applicationId}`,
  GetAssetsById: (assetId: any, applicantId: any) =>
    `${applicationBase}/AssetsLiabilities/GetAssetsById?assetId=${assetId}&applicantId=${applicantId}`,
  DeleteApplicantAsset: `${applicationBase}/AssetsLiabilities/DeleteApplicantAsset`,
  AddOrUpdateApplicantAsset: `${applicationBase}/AssetsLiabilities/AddOrUpdateApplicantAsset`,
  updateGeneralDetails: `${applicationBase}/Applications/UpdateGenralDetails`,
  applicationProductSnapAPI: (applicationId: number) =>
    `${applicationBase}/Applications/ApplicationProductSnapAPI?requestId=REQ-123456&applicationId=${applicationId}`,
  productById: (productId: number) =>
    `${productBase}/Product/GetProductSummaryById?productId=${productId}`,
  getProductSummariesByIds: (productIds: number[]) =>
    `${productBase}/Product/GetProductByProductIds?${productIds.map((id) => `productId=${id}`).join('&')}`,
  LCSApplicationSummary: `${applicationBase}/LCS/ApplicationSummary`,
  ApplicantById: (applicantId: number) =>
    `${applicationBase}/Applicants/GetApplicantById?ApplicantId=${applicantId}`,
  exportApplications: `${applicationBase}/applications/ExportApplicationsRecord`,
  downloadExport: `${applicationBase}/applications/DownloadExport`,
  exportStatus: `${applicationBase}/applications/ExportJobStatus`,
  CreditReport: (applicationId: number, applicantId: number) =>
    `${applicationBase}/CreditReport/GetApplicantCreditReport?applicationId=${applicationId}&applicantId=${applicantId}`,
  applicantCompliancesById: (applicantId: number) =>
    `${applicationBase}/api/ApplicantCompliances/GetAllCompliance?requestId=REQ-123456&ApplicantId=${applicantId}`,
  updateApplicant: `${applicationBase}/Applicants/UpdateApplicant`,
  updateEmployer: `${applicationBase}/Applicants/UpdateEmployer`,
  updateApplicantIncome: `${applicationBase}/Applicants/AddOrUpdateApplicantOtherIncomes`,
  updateApplicantCompliance: `${applicationBase}/api/ApplicantCompliances/AddOrUpdateApplicantCompliance`,
  addIdentificationDetails: `${applicationBase}/Applicants/AddIdentificationDetails`,
  getCountryList: (languageCode: string) =>
    `${applicationBase}/api/Country/GetAllCountries?LanguageCode=${languageCode}`,

  getProvinceList: (CountryId: number) =>
    `${applicationBase}/api/Provinces/GetAllProvinces?countryId=${CountryId}`,

  //getProvinceList: `${applicationBase}/api/Provinces/GetAllProvinces`,
  applicationProducts: (applicationId: number) =>
    `${applicationBase}/api/ApplicationProducts/GetAllApplicationProducts?applicationId=${applicationId}`,
  conditionAndPolicyByApplicationProductId: (applicationProductId: number) =>
    `${applicationBase}/ConditionAndPolicy/GetByApplicationProductId?applicationProductId=${applicationProductId}`,
  getSitesConditionAndPolicy: `${productBase}/GetAllSiteProductType`,
  postConditionOrPolicy: `${applicationBase}/ConditionAndPolicy`,
  applicantLibilitiesByGroup: (applicationId: number) =>
    `${applicationBase}/AssetsLiabilities/GetApplicationLiabilitiesByGroup?applicationId=${applicationId}`,
  getLiabilityByApplicantId: (applicationId: number) =>
    `${applicationBase}/AssetsLiabilities/GetLiabilityByApplicantId?applicationId=${applicationId}`,
  GetLiabilityById: (libilityId: any, applicantId: any) =>
    `${applicationBase}/AssetsLiabilities/GetLiabilityById?liabilityId=${libilityId}&applicantId=${applicantId}`,
  DeleteApplicantLiability: `${applicationBase}/AssetsLiabilities/DeleteApplicantLiability`,
  AddApplicantLibility: `${applicationBase}/AssetsLiabilities/AddApplicantLibility`,
  AddOrUpdateMultiLiability: `${applicationBase}/AssetsLiabilities/AddOrUpdateMultiLiability`,
  ImportLiabilityFromCreditReport: `${applicationBase}/CreditReport/ImportLiabilityFromCreditReport`,
  GetLiabilityFromCreditReport: (
    applicationId: number,
    fromImportapplication: boolean = true,
    applicantId?: number
  ) => `${applicationBase}/CreditReport/GetLiabilityFromCreditReport?applicationId=${applicationId}&fromImportapplication=${fromImportapplication}&applicantId=${applicantId}`,
  getAllTerms: (productId: number) =>
    `${productBase}/ProductTerm/GetByProductId?productId=${productId}`,
  getAmortization: (productId: number) =>
    `${productBase}/ProductAmortization/GetByProductId?productId=${productId}`,
  getPaymentFrequency: (productId: number) =>
    `${productBase}/ProductPaymentFrequency/GetByProductId?productId=${productId}`,
  getApprovalAutoDecision: `${applicationBase}/LDS/GetApprovalAutoDecision`,
  getRateAutoDecision: `${applicationBase}/LDS/GetRateAutoDecision`,
  getPaymentSummary: `${applicationBase}/PCS/GetPaymentSummary`,
  getPaymentAmount: `${applicationBase}/PCS/GetPaymentAmount`,
  updateApplicationProductTerm: `${applicationBase}/api/ApplicationProducts/UpdateApplicationProductTerm`,
  getApplicationProductTermDetail: (applicationProductId: number) =>
    `${applicationBase}/api/ApplicationProducts/GetApplicationProductTermDetail?applicationProductId=${applicationProductId}`,
  updateApplicationProductTermDetailRate: `${applicationBase}/api/ApplicationProducts/UpdateApplicationProductTermDetailRate`,
  updateApplicationProduct: `${applicationBase}/api/ApplicationProducts/UpdateApplicationProducts`,
  getProductAdditionalFees: (productId: number) =>
    `${productBase}/ProductAdditionalFees?productId=${productId}`,
  updateProductAdditionalFees: `${productBase}/ProductAdditionalFees/AddUpdateProductAdditionalFees`,
  getRateCurrentVersion: `${applicationBase}/LDS/GetRateCurrentVersion`,
  getApprovalCurrentVersion: `${applicationBase}/LDS/GetApprovalCurrentVersion`,
  getRateList: `${applicationBase}/LDS/Getratelist`,
  getApplicantDocumentPortal: (applicantId: number) =>
    `${applicationBase}/DocumentPortal/GetApplicantDocumentPortal?applicantId=${applicantId}`,
  deleteApplicantDocument: `${applicationBase}/DocumentPortal/DeleteApplicantDocumentPortal`,
  downloadApplicantDocument: `${applicationBase}/DocumentPortal/DownloadApplicantDocument`,
  getAllApplicants: (applicationId: number) =>
    `${applicationBase}/Applicants/GetAllApplicants?applicationId=${applicationId}`,
  addApplicantDocument: `${applicationBase}/DocumentPortal/AddApplicantDocumentPortal`,
  getApplicationDocuments: `${applicationBase}/ApplicationDocument/GetAllApplicationDocumentFilterWithDocumentIds`,
  documentPreviewDownload: `${applicationBase}/DocumentPreview/Download`,
  documentPreviewPreview: `${applicationBase}/DocumentPreview/Preview`,
  getAllDocumentViaApplicationId: (applicantionId: number) =>
    `${applicationBase}/ApplicationDocument/GetAllViaApplication?applicationId=${applicantionId}`,
  getAllApplicantDocViaApplicationId: `${applicationBase}/ApplicationDocument/GetAll`,
  refreshDocument: (applicationIds: string, intervalTimeInMin: number) =>
    `${applicationBase}/ApplicationDocument/RefreshDocument?${applicationIds}&IntervalTimeInMin=${intervalTimeInMin}`,
  documentSigning: `${applicationBase}/Document/DocumentSigning`,
  downloadApplicationZip: (applicationId: number, defaultCountry: string) =>
    `${applicationBase}/applications/ExportApplicationZip?applicationId=${applicationId}&defaultCountry=${defaultCountry}`,
  printApplication: (applicationId: number, defaultCountry: string) =>
    `${applicationBase}/applications/PrintApplicationSummary?applicationId=${applicationId}&defaultCountry=${defaultCountry}`,
  downloadDocumentPackage: `${applicationBase}/Document/DownloadDocumentPackage`,
  SendDocumentPackage: `${applicationBase}/Document/SendDocumentPackage`,
  SendDocument: `${applicationBase}/Document/SendDocument`,
  getDocumentConfigurationByDocId: (
    documentId: number,
    applicationId: number
  ) =>
    `${applicationBase}/ApplicationDocument/GetDocumentConfigurationByDocId?documentId=${documentId}&applicationId=${applicationId}`,
  sendDocumentDownload: `${applicationBase}/Document/SendDocumentDownload`,
  documentSendByDocuSign: `${applicationBase}/Document/DocumentSendByDocuSign`,
  SendCompleteStatusMail: (applicationId: number) =>
    `${applicationBase}/Applications/SendCompleteStatusMail?requestId=qw&applicationId=${applicationId}`,
  SendProductSummaryMail: (applicationId: number) =>
    `${applicationBase}/Applications/SendProductSummaryMail?requestId=qw&applicationId=${applicationId}`,
  AddApplicationLog: `${applicationBase}/Applications/AddApplicationLog`,
  ApplicationResumeByStaff: `${applicationBase}/Applications/ApplicationResumeByStaff`,
  NewApplicationStartByStaff: `${applicationBase}/Applications/NewApplicationStartByStaff`,

  //core banking
  getPersonNumbers: `${memberBase}/BankIOApplication/GetPersonIdByMemberNumber`,
  getApplicantsFromCoreBanking: `${coreBankingBase}/Applicant/GetAllApplicants`,
  updateApplicantInCoreBanking: `${applicationBase}/CoreBanking/UpdateApplicant`,
  commitApplicantInCoreBanking: `${applicationBase}/CoreBanking/CommitApplicant`,
  commitDepositeInCoreBanking: `${applicationBase}/CoreBanking/CommitDiposite`,
  commitLendingInCoreBanking: `${applicationBase}/CoreBanking/CommitLoan`,


  //Bank Integration
  getBankIntegration: `${coreBankingBase}/BankIntegration/GetList`,

  // Product Type
  getProductTypeByProductType: `${productBase}/GetByProductType`,
  UpdateSiteProductType: `${productBase}/UpdateSiteProductType`,

  // Identity Verification
  getApplicantIdentityVerification: (applicantId: number) =>
    `${applicationBase}/api/ApplicantIdentityVerification/GetApplicantIdentityVerification?applicantID=${applicantId}`,
  addUpdateDeleteApplicantIdentityVerification: `${applicationBase}/api/ApplicantIdentityVerification/SingleAddORUpdateApplicantIdentityVerification`,
  deleteApplicantIdentityVerification: `${applicationBase}/api/ApplicantIdentityVerification/DeleteApplicantIdentityVerification`,
};

export const CrmUrls = {
  branches: (type: 'Site' | 'Client') => `${apiBase}/branches?type=${type}`,
  weather: `${apiBase}/weather`,
  forecast: `${apiBase}/forecast`,
};

export const KeyVaultUrls = {
  keyVaultValue: (key: string) => `${keyVaultBase}?key=${key}`,
};

export const CommonUrls = {
  sites: `${userManagementBase}/sites`,
  site: `${userManagementBase}/sites/site`,
};

export const TagsUrls = {
  tags: `${ecmBase}/tags`,
  tag: (id: number) => `${ecmBase}/tags/${id}`,
};

export const ThemeUrls = {
  getStyle: (
    type:
      | 'CustomThemeColors'
      | 'CustomStyles'
      | 'DefaultThemeColors'
      | 'OriginationThemeColors'
      | 'OriginationStyles'
  ) => `${apiBase}/theme-builder/styles/${type}`,
  themeStyles: `${apiBase}/theme-builder/styles`,
  themeImage: `${apiBase}/theme-builder/image`,
  revertImages: `${apiBase}/theme-builder/revertImage`,
};

export const AosUrls = {
  application: (type: ApplicationsTypeEnum, id: number) =>
    `${getCurrentAosBase()}/manage/${type === ApplicationsTypeEnum.Retail
      ? 'applications'
      : 'businessapplications'
    }/edit/${id}`,
  applications: (type: ApplicationsTypeEnum, status?: number) => {
    const statusFilter = status === null || status === undefined ? '' : status;
    const appType =
      type === ApplicationsTypeEnum.Retail
        ? 'applications'
        : 'businessapplications';
    const url = `${getCurrentAosBase()}/manage/${appType}?Status=${statusFilter}`;

    return url;
  },
};

export const EcmUrls = {
  file: `${ecmBase}/file`,
  files: `${ecmBase}/files`,
  archivefiles: `${ecmBase}/files/archive`,
  fileById: (id: number) => `${ecmBase}/files/${id}`,
  filesSummary: `${ecmBase}/files-summary`,
  uploadFile: `${ecmBase}/files/upload`,
  loadFile: `${ecmBase}/files/load`,
  folders: `${ecmBase}/folders`,
  folderById: (id: number) => `${ecmBase}/folders/${id}`,
  folderContent: `${ecmBase}/folders/content`,
  types: `${ecmBase}/file-types`,
  getSubTypes: `${ecmBase}/file-sub-types/`,
  applicationDetails: `${ecmBase}/files/ApplicationId`,
  checkECMFolderGroup: (groupId) =>
    `${ecmBase}/folders/checkusergroupassociation/${groupId}`,
  fileAccess: `${ecmBase}/files/checkaccess`,
};

export const VersioningUrls = {
  versioningDetails: (version: string) =>
    `${versioningBase}/version-search/retrieve?version=${version}`,
  currentUmbrellaVersion: (EnvironmentName: string) =>
    `${versioningBase}/umbrella-version/retrieveUmbrellaVersion?environment=${EnvironmentName}`,
};

export const OfferUrls = {
  OfferTemplates: `${offerBase}/offer-templates`,
  offerTemplate: (id: number) => `${offerBase}/offer-template/${id}`,
  OfferTemplateIcons: (id: number) => `${offerBase}/offer-Template-Icons`,
  files: `${offerBase}/files`,
  offerImports: `${offerBase}/offer-imports`,
  offerImport: (id: number) => `${offerBase}/offer-imports/${id}`,
  offerImportTemplate: `${offerBase}/offer-imports/template`,
  offers: `${offerBase}/offer-members`,
  offer: (id: number) => `${offerBase}/offer-members/${id}`,
  offerMemberStatus: (id: number) => `${offerBase}/offerMemberStatus/${id}`,
  offerActivity: `${offerBase}/offer-activity-logs`,
  MemberOffers: `${offerBase}/offer-members`,
  OfferSite: `${offerBase}/site`,
  OfferUser: `${offerBase}/offer-user`,
  offerUsers: `${offerBase}/offer-users`,
  OfferBranches: (siteId: string) => `${offerBase}/offer-branches/${siteId}`,
  OfferUserEnable: `${offerBase}/offer-user-enable`,
};

export const ProspectUrls = {
  prospects: `${memberBase}/Prospect/GetProspectByIds`,
  Prospect: `${memberBase}/Prospect/Add`,
  prospect: (memberId: number) => `${memberBase}/prospectsummary/${memberId}`,
  importProspect: (memberNumber: string, memberType: string) =>
    `${memberBase}/prospectsummary/${memberNumber}/${memberType}/sync`,
  importProspectById: (memberId: number) =>
    `${memberBase}/prospectsummary/${memberId}/prospectsync`,
  prospectStatus: `${memberBase}/Prospect/UpdateStatus`,
  deleteProspect: (ProspectId: number) =>
    `${memberBase}/Prospect/Delete/${ProspectId}`,
  mergeProspect: `${memberBase}/Prospect/MergeProspect`,
  Status: (Id: number, ProspectStatus: string) =>
    `${memberBase}/prospectsummary/${Id}/${ProspectStatus}`,
  prospectInformation: (ProspectId: number) =>
    `${memberBase}/Prospect/GetProspectById/${ProspectId}`,
  updateProspectInformation: `${memberBase}/Prospect/Update`,
  prospectContactPreference: (ProspectId: number) =>
    `${memberBase}/prospectsummary/GetProspectContactById/${ProspectId}`,
  updateProspectContactPreference: `${memberBase}/prospectsummary/UpdateProspectContact`,
  getProspectContact: (prospectId: number, contactId: number) =>
    `${memberBase}/prospects/${prospectId}/contacts/${contactId}`,
  createProspectContacts: (prospectId: number) =>
    `${memberBase}/prospects/${prospectId}/contacts`,
  updateProspectContact: (prospectId: number, contactId: number) =>
    `${memberBase}/prospects/${prospectId}/contacts/${contactId}`,
  deleteProspectContact: (prospectId: number, contactId: number) =>
    `${memberBase}/prospects/${prospectId}/contacts/${contactId}`,
  accessHistory: (memberId: number) =>
    `${memberBase}/profilehistory?MemberorProspectId=${memberId}`,
  prospectaddresses: (personId: number, type: string) =>
    `${memberBase}/${type}/${personId}/addresses?pageNumber=0&pageSize=5`,
  deleteAddresses: (addressId: number, personId: number) =>
    `${memberBase}/prospect/${personId}/addresses/${addressId}`,
  getAddressFields: (countryCode: string, addressType: string) =>
    `${memberBase}/GetAddressFields?countryCode=${countryCode}&addressType=${addressType}`,
  getAddressFieldsById: (countryCode: number, addressType: string) =>
    `${memberBase}/GetAddressFields?countryCode=${countryCode}&addressType=${addressType}`,
  getAddressFieldsByCountryId: (countryId: number, addressType: string) =>
    `${memberBase}/GetAddressFields/GetLableByAddressType?CountryId=${countryId}&addressType=${addressType}`,
  getCountries: (languageCode: string = 'Eng') =>
    `${applicationBase}/api/Country/GetAllCountries?LanguageCode=${languageCode}`,
  getProvincesByCountryId: (countryId: number) =>
    `${applicationBase}/api/Provinces/GetAllProvinces?countryId=${countryId}`,
  powerBiUrl: `${memberBase}/site/powerbiurl`,
};

export const LendingDecisioningUrls = {
  approvalModels: `${LDSBase}/ApprovalModel/GetAll`,
  approvalModel: (id: number) => `${LDSBase}/ApprovalModel/GetById?id=${id}`,
  approvalModelByVersion: (version: string, id: number) =>
    `${LDSBase}/ApprovalModel/ApprovalModelByVersionName?id=${id}&versionName=${version}`,
  approvalModelCreate: `${LDSBase}/ApprovalModel/AddApproval`,
  approvalModelsName: `${LDSBase}/ApprovalModel/GetModelsNameForImport`,
  approvalModelUpdate: `${LDSBase}/ApprovalModel/UpdateApproval`,
  approvalModelDelete: (id: number) =>
    `${LDSBase}/ApprovalModel/DeleteApproval?approvalModelId=${id}`,
  approvalExclusionParameter: `${LDSBase}/Parameter/GetParameterList`,
  rateModels: `${LDSBase}/RateModel/GetAllRates`,
  rateModelDelete: (id: number) =>
    `${LDSBase}/RateModel/DeleteRate?rateModelId=${id}`,
  rateModel: (id: number) => `${LDSBase}/RateModel/GetById?id=${id}`,
  rateModelByVersion: (version: string, id: number) =>
    `${LDSBase}/RateModel/RateModelByVersionName?id=${id}&versionName=${version}`,
  rateModelUpdate: `${LDSBase}/RateModel/UpdateRate`,
  rateModelCreate: `${LDSBase}/RateModel/AddRate`,
  rateModelsName: `${LDSBase}/RateModel/GetRateModelsNameForImport`,
  rateModifierParameter: `${LDSBase}/Parameter/GetParameterList`,
  rateMatrixParameter: `${LDSBase}/Parameter/GetParameterList`,
};

export const ConfigurationManagementUrls = {
  siteConfigurationDetails: `${configurationManagementApiBase}/SiteConfiguration`,
  getSiteSecureConfigurationsBySiteId: `${configurationManagementApiBase}/Site/getSiteSecureConfigurationsBySiteId`,
  getSiteApplicationConfigurationsBySiteId: `${configurationManagementApiBase}/Site/getSiteApplicationConfigurationsBySiteId`,

  siteDetails: `${asappApiBase}/site`,
  getApplicationConfigurationBySiteId: `${configurationManagementApiBase}/ApplicationConfiguration/GetBySiteId`,
  getLanguageDatabySiteId: (siteId: string) =>
    `${configurationManagementApiBase}/SiteConfiguration`,
  getEquifaxConfiguration: `${configurationManagementApiBase}/EquifaxConfiguration/CheckEquifaxConfigurations`,
};

export const IdentityVerificationUrl = {
  IdentityFetchTelcoSignzy: `${identityVerificationApiBase}/signzy/TelcoAndSignzyLogDetails`,
  IdentityFetchKount: `${identityVerificationApiBase}/kount/GetKountdatailByApplicanIds`,
  RunKount: `${identityVerificationApiBase}/kount/KountVerification`,
  IdentityDeleteKount: (applicantId: string) => `${identityVerificationApiBase}/kount/${applicantId}`,
  IdentityUpdateKount: (logId: number, isMarkedAsReview: boolean) => `${identityVerificationApiBase}/kount/UpdateServiceLog?logId=${logId}&isMarkedAsReview=${isMarkedAsReview}`,
  IdentityFetchFlinksTransactions: (applicantId: string) => `${identityVerificationApiBase}/flinks/GetTransactionsDetails/${applicantId}`,
  IdentityFetchFlinksModel: (applicantId: string) => `${identityVerificationApiBase}/flinks/GetApplicantFlinksModel/${applicantId}`,
};
export const CoreBankingUrl = {
  GetActivities: (entityId: number, isBusiness: boolean) =>
    `${coreBankingBase}/IntegrationActivityLog/GetActivities?entityId=${entityId}&isBusiness=${isBusiness}`,
  GetLogs: (entityId: number, isBusiness: boolean) =>
    `${coreBankingBase}/IntegrationActivityLog/GetLogs?entityId=${entityId}&isBusiness=${isBusiness}`,
  //IntegrationActivityLog/GetActivities?entityId=111&isBusiness=false
};

export const DocumentManagementUrl = {
  getAllDocumentTemplate: `${documentManagementService}/Document/GetAllDocuments`,
  updateDocumentTemplate: `${documentManagementService}/Document/UpdateDocument`,
  updateSigningSequence: `${documentManagementService}/Document/UpdateSigningSequence`,
  getDocumentTemplateById: `${documentManagementService}/Document/GetDocumentById`,
  getFileTypes: `${documentManagementService}/ECM/GetAllFileType`,
  getSubTypes: `${documentManagementService}/ECM/GetAllFileSubType`,
  createTemplate: `${documentManagementService}/Document/AddDocument`,
  tags: `${documentManagementService}/Sync/GETAllTags`,
  updateDocumentTemplateField: `${documentManagementService}/DocumentFields/UpdateFields`,
  getAllSourceFields: `${documentManagementService}/Resources/GetAllSourceFields`,
  downloadTemplatePDF: `${applicationBase}/Document/Download`,
  downloadPreviewPDF: `${applicationBase}/Document/Preview`,
  documentConfiguration: {
    getAll: `${documentManagementService}/DocumentConfiguration/GetAll`,
    getDocumentById: `${documentManagementService}/DocumentConfiguration/GetDocumentConfigurationById`,
    getAllActiveTemplateName: `${documentManagementService}/Document/GetAllActiveTemplateName`,
    getAllProduct: `${documentManagementService}/Sync/GetSyncProducts`,
    getAllDeclaration: `${documentManagementService}/Sync/GetSyncedDeclarations`,
    addDocumentConfiguration: `${documentManagementService}/DocumentConfiguration/AddConfiguration`,
    getActiveNotMappedDocumentTemplateByLanguage: `${documentManagementService}/Document/GetActiveNotMappedDocument`,
    deleteConfiguration: `${documentManagementService}/DocumentConfiguration/DeleteConfiguration`,
    updateConfiguration: `${documentManagementService}/DocumentConfiguration/UpdateConfiguration`,
    getShared: `${documentManagementService}/DocumentConfiguration/GetShared`,
    getNonShared: `${documentManagementService}/DocumentConfiguration/GetNonShared`,
  },
};

export const BankIoRetailUrl = {
  promoPage: `${bankIoRetailBase}`,
};
